import type { ProjectTask, TaskStatus } from "@/types/models";

const terminalStatuses: TaskStatus[] = ["Complete", "Not applicable"];

export function detailSectionForStatusChange(
  task: ProjectTask,
  status: TaskStatus,
  authorizedTasks: readonly ProjectTask[],
): "overview" | "structure" | null {
  if (status === "Blocked") return "overview";
  if (
    terminalStatuses.includes(task.status) &&
    !terminalStatuses.includes(status)
  )
    return "overview";
  if (
    status === "Complete" &&
    task.predecessorIds.some((id) => {
      const predecessor = authorizedTasks.find(
        (candidate) => candidate.id === id,
      );
      return predecessor && !terminalStatuses.includes(predecessor.status);
    })
  )
    return "structure";
  return null;
}
